import React from "react";
import TopSummary from "../top-summary/TopSummary";
import mokomokoGray from "../../static/images/mokomoko-gray.png";
import rabbitWinkNormal from "../../static/images/rabbit-wink-normal.png";
import classes from "./MisaSupportSection.module.scss";
import MisaBrandEmptyState from "./MisaBrandEmptyState";
import MisaBrandSelector from "../misa-brand-selector/MisaBrandSelector";
import { MisaBrand } from "../../pages/misa-top/MisaTypes";

type Props = {
  isSelectorOpen: boolean;
  isChildSelected: boolean;
  brands: MisaBrand[];
  onSelectBrandButton: () => void;
  onBrandClick: (brand: MisaBrand) => void;
  onBackClick: () => void;
};

const MisaSupportSection = ({
  isSelectorOpen,
  isChildSelected,
  brands,
  onSelectBrandButton,
  onBrandClick,
  onBackClick,
}: Props) => {
  // 保有口数がある銘柄だけを抽出し、通常表示時の対象にする。
  const investedBrands = brands.filter(
    (brand) => (brand.holdingUnits ?? 0) > 0
  );
  const hasInvestedBrands = investedBrands.length > 0;

  // 銘柄選択中は全銘柄、通常時は既に推している銘柄のみ表示する。
  const displayedBrands = isSelectorOpen ? brands : investedBrands;

  return (
    <section
      className={`${classes.supportSection} ${
        isChildSelected ? classes.childSelectedSupportSection : ""
      }`}
    >
      <div className={classes.summary}>
        <TopSummary
          leftLogo={rabbitWinkNormal}
          mainTitle="あなたの「推し」"
          rightLogo={mokomokoGray}
        />
      </div>

      {/* まだ推し銘柄がない通常表示では、銘柄選択へ誘導する空状態を表示する。 */}
      {!isSelectorOpen && !hasInvestedBrands && (
        <MisaBrandEmptyState onSelectBrand={onSelectBrandButton} />
      )}

      {/* 推し銘柄の一覧表示と、銘柄選択モードの表示を同じセレクターで切り替える。 */}
      <MisaBrandSelector
        brands={displayedBrands}
        isChildSelected={isChildSelected}
        showCards={isSelectorOpen || hasInvestedBrands}
        showBackButton={isSelectorOpen}
        actionButtonLabel={
          !isSelectorOpen && hasInvestedBrands
            ? "推しを増やす"
            : undefined
        }
        onBrandClick={onBrandClick}
        onBackClick={onBackClick}
        onActionButton={onSelectBrandButton}
      />
    </section>
  );
};

export default MisaSupportSection;
